import React from 'react';
import { Form } from 'react-bootstrap';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import Textarea from '../../../components/Textarea/Textarea';

const SurveyFolderForm = ({ changeHandler, submitHandler, name, description, nameError, disabled = false }) => {
  return (
    <Form onSubmit={submitHandler}>
      <div className="row">
        <div className="col-md-12">
          <Input
            label="Name"
            type="text"
            name="name"
            value={name}
            placeholder="e.g. Parent Feedback 2026-27"
            onChangeHandler={changeHandler}
            required={true}
            error={nameError}
          />
        </div>
        <div className="col-md-12">
          <Textarea
            label="Description"
            type="text"
            name="description"
            value={description}
            placeholder="What lives in this folder"
            onChangeHandler={changeHandler}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <div className="mt-3">
          <Button variant="primary" type="submit" disabled={disabled}>
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default SurveyFolderForm;
